import React from "react";
import PageHeader from "src/componets/PageHeader";
import { useLocation, useSearchParams } from "react-router-dom";
import { queryParams } from "../../../../helpers/UrlHelpers";

const _PageHeader: React.FC = () => {
  const [searchParams] = useSearchParams();
  const { pathname } = useLocation();
  const isUnpublished = pathname.includes('unpublished');
  const type = isUnpublished ? 'Unpublished' : (queryParams.get(searchParams, 'kind') || 'All');

  return <PageHeader title='Servers' breadcrumbs={[type]}/>;
}

export default _PageHeader;
